import { render, staticRenderFns } from "./AdminBatchInquiryList.vue?vue&type=template&id=74f13379"
import script from "./AdminBatchInquiryList.vue?vue&type=script&lang=js"
export * from "./AdminBatchInquiryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports